/* eslint-disable @typescript-eslint/naming-convention */
import { IShipment } from "../../model/Shipment";
import { ActionsUnion, createAction } from "../definitions";
import { ShipmentActionTypes } from "./types";

export interface IShipmentPayload {
    keyId: string;
    shipments: IIdDictionary<IShipment>;
}

export const ShipmentActions = {
    setShipments: (payload: IShipmentPayload) => createAction(ShipmentActionTypes.SET_SHIPMENTS, payload),
    clearUserShipments: (userId: string) => createAction(ShipmentActionTypes.CLEAR_USER_SHIPMENTS, userId),
    clearDeviceShipments: (deviceId: string) => createAction(ShipmentActionTypes.CLEAR_DEVICE_SHIPMENTS, deviceId),
    clearAllShipments: () => createAction(ShipmentActionTypes.CLEAR_ALL_SHIPMENTS)
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ShipmentActions = ActionsUnion<typeof ShipmentActions>;